import { Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { StoreHelper } from '../../shared/helpers/store.helper';
import Hls from 'hls.js';
import { isBeta } from '../../shared/services';
import { ControllerService } from '../../shared/services/controller.service';
import { BunnyMapService } from '../../shared/services/bunny-map.service';

@Component({
  selector: 'app-bunny-intro-video',
  templateUrl: './bunny-intro-video.component.html',
  styleUrls: ['./bunny-intro-video.component.scss'],
  standalone: false
})
export class BunnyIntroVideoComponent implements OnInit, OnDestroy {

  current: number = 0;
  duration: number = 0;
  progressValue: number = 0;
  underPlay: boolean = false;
  loadedPlay: boolean = false;
  OnCaption: boolean = false;
  lastEvent: any;
  lastUpdated: number = 0;
  updateInterval: number = 1000;
  isBeta: boolean = isBeta();
  skipToEnd: boolean = false;
  disableFullScreen = false;
  isReplay = false;
  posterUrl: string = '';

  private hls: Hls | null = null;

  @ViewChild('videoEl', { static: true }) videoElRef!: ElementRef<HTMLVideoElement>;

  private get video(): HTMLVideoElement {
    return this.videoElRef.nativeElement;
  }

  constructor(
    public controller: ControllerService,
    private bunnyMapService: BunnyMapService
  ) {}

  ngOnDestroy(): void {
    document.querySelectorAll<HTMLElement>('.main-link').forEach(el => el.style.display = '');
    this.hls?.destroy();
    this.controller.toggleLoading(false);
  }

  ngOnInit() {
    this.controller.toggleLoading(false);
    this.onLoadVideo();
    this.videobgEnlarge();

    document.getElementById('video-with-controls')?.addEventListener('fullscreenchange', () => {
      if (document.fullscreenElement === null) {
        this.underPlay = false;
        this.video.pause();
      }
    });

    this.offTextTracks();
    this.skipToEnd = StoreHelper.getObject('fastForward');
  }

  private offTextTracks() {
    const tracks = this.video.textTracks;
    for (let i = 0; i < tracks.length; i++) {
      tracks[i].mode = 'disabled';
    }
  }

  onMediaTimeUpdate(data: { seconds: number; percent: number; duration: number }) {
    this.current = data.seconds;
    this.duration = data.duration;
    this.progressValue = data.percent * 100;
    if (this.progressValue > 0) {
      this.controller.toggleLoading(false);
    }
  }

  @HostListener('document:mousemove')
  onMouseMove() {
    if (this.underPlay) {
      this.lastEvent = new Date().getTime();
      this.fadeInControls();
    }
  }

  fadeOutControls() {
    const el = document.querySelector<HTMLElement>('.controls-container');
    if (el && el.style.opacity !== '0') {
      el.style.opacity = '0';
    }
  }

  fadeInControls() {
    const el = document.querySelector<HTMLElement>('.controls-container');
    if (el && el.style.opacity !== '1') {
      el.style.opacity = '1';
    }
  }

  onClickProgress(e: MouseEvent) {
    const target = e.target as HTMLElement;
    const x = e.pageX - target.offsetLeft;
    const clickedValue = x / target.clientWidth;
    if (clickedValue < 1) {
      const newTime = Math.floor(clickedValue * this.duration);
      this.video.currentTime = newTime;
      this.onMediaTimeUpdate({ seconds: newTime, duration: this.duration, percent: newTime / this.duration });
    }
  }

  onMediaEnd() {
    this.underPlay = false;
    this.onNext();
    document.querySelectorAll<HTMLElement>('.main-link').forEach(el => el.style.display = '');
    document.exitFullscreen().catch(() => {});
  }

  onPlay() {
    document.querySelector('.play-next-wrapper')?.classList.add('hide');
    this.video.play().catch(() => {
      this.underPlay = false;
      document.querySelector('.play-next-wrapper')?.classList.remove('hide');
      document.querySelectorAll<HTMLElement>('.main-link').forEach(el => el.style.display = '');
    });
    this.underPlay = true;
    this.videobgEnlarge();
    setTimeout(() => this.videobgEnlarge(), 10);
    document.querySelectorAll<HTMLElement>('.main-link').forEach(el => el.style.display = 'none');

    if (!this.disableFullScreen) {
      document.getElementById('video-with-controls')?.requestFullscreen();
    }

    if (this.skipToEnd) {
      if (this.video.duration) {
        this.video.currentTime = this.video.duration - 2;
      } else {
        this.video.addEventListener('loadedmetadata', () => {
          this.video.currentTime = this.video.duration - 2;
        }, { once: true });
      }
    }
  }

  onBackward() {
    if (this.underPlay && (this.current - 5) > 0) {
      this.current -= 5;
      this.video.currentTime = this.current;
    }
  }

  onForward() {
    if (this.underPlay && (this.current + 5) < this.duration) {
      this.current += 5;
      this.video.currentTime = this.current;
    }
  }

  onPause() {
    this.video.pause();
    this.underPlay = false;
    document.querySelectorAll<HTMLElement>('.main-link').forEach(el => el.style.display = '');
  }

  OnSubtitles() {
    const tracks = this.video.textTracks;
    for (let i = 0; i < tracks.length; i++) {
      const track = tracks[i];
      if (track.kind === 'subtitles' || track.kind === 'captions') {
        track.mode = 'showing';
        break;
      }
    }
    this.OnCaption = true;
  }

  OffSubtitles() {
    this.offTextTracks();
    this.OnCaption = false;
  }

  onNext() {
    this.controller.next(false, false, true);
  }

  @HostListener('window:resize')
  onResize() {
    setTimeout(() => this.videobgEnlarge(), 10);
  }

  videobgEnlarge() {
    const videoBgAspect = document.querySelector<HTMLElement>('.fullScreen .videobg-aspect');
    const videoBgWidth = document.querySelector<HTMLElement>('.fullScreen .videobg-width');
    const controlContainer = document.querySelector<HTMLElement>('.fullScreen .videobg-width .controls-container');
    if (!videoBgAspect || !videoBgWidth || !controlContainer) return;

    const videoAspect = videoBgAspect.offsetHeight / videoBgAspect.offsetWidth;
    const windowAspect = window.innerHeight / window.innerWidth;
    const calculated = 100 * (videoAspect - (windowAspect - 0.06));
    controlContainer.style.bottom = Math.max(calculated, 10) + '%';

    if (windowAspect > videoAspect) {
      const calculationWith = (windowAspect / videoAspect) * 100;
      videoBgWidth.style.width = calculationWith + '%';
      if (calculationWith > 100) {
        const leftPosition = calculationWith - 100;
        controlContainer.style.width = (100 - leftPosition) + '%';
        controlContainer.style.left = (leftPosition / 2) + '%';
      }
    } else {
      videoBgWidth.style.width = '100%';
      controlContainer.style.width = '100%';
      controlContainer.style.left = '0';
    }
  }

  checkIfPlaying() {
    if (!this.underPlay) {
      document.querySelector('.play-next-wrapper')?.classList.remove('hide');
    } else {
      this.controller.toggleLoading(false);
    }
  }

  onLoadVideo() {
    this.loadedPlay = true;
    this.lastEvent = new Date().getTime();
    this.controller.toggleLoading(true);

    const component = this.controller.getSectionComponents()[0];
    const vimeoId = component?.properties?.vimeoId;
    this.disableFullScreen = component?.properties?.disableFullScreen === 'true';
    this.isReplay = this.controller.getAfterRewind() || this.controller.getPreviewing();

    const bunnyId = component?.properties?.bunnyId || this.bunnyMapService.getBunnyId(vimeoId);
    const src = this.bunnyMapService.getPlaylistUrl(bunnyId);
    this.posterUrl = this.bunnyMapService.getThumbnailUrl(bunnyId);

    if (Hls.isSupported()) {
      this.hls = new Hls();
      this.hls.on(Hls.Events.MANIFEST_PARSED, () => this.onPlay());
      this.hls.loadSource(src);
      this.hls.attachMedia(this.video);
    } else {
      // Safari supports HLS natively
      this.video.addEventListener('loadedmetadata', () => this.onPlay(), { once: true });
      this.video.src = src;
    }

    const captionTrack = document.createElement('track');
    captionTrack.kind = 'captions';
    captionTrack.label = 'English';
    captionTrack.srclang = 'GB';
    captionTrack.src = this.bunnyMapService.getCaptionsUrl(bunnyId);
    captionTrack.addEventListener('error', () => {
      captionTrack.src = this.bunnyMapService.getCaptionsUrl(bunnyId, 'EN');
    }, { once: true });
    this.video.appendChild(captionTrack);

    this.video.volume = 1;

    this.video.addEventListener('timeupdate', () => {
      const current = this.video.currentTime;
      const duration = this.video.duration;
      const percent = duration ? current / duration : 0;

      if (this.lastEvent && this.lastEvent < new Date().getTime() - 5000) {
        this.lastEvent = new Date().getTime();
        this.fadeOutControls();
      }

      if (!this.lastUpdated || this.lastUpdated + this.updateInterval < Date.now()) {
        this.lastUpdated = Date.now();
        this.onMediaTimeUpdate({ seconds: current, percent, duration });
      }
    });

    this.video.addEventListener('loadedmetadata', () => {
      this.onMediaTimeUpdate({ seconds: 0, percent: 0, duration: this.video.duration });
      this.controller.toggleLoading(false);
    });

    this.video.addEventListener('ended', () => {
      this.current = this.duration;
      this.onMediaEnd();
    });

    setTimeout(() => this.checkIfPlaying(), 3000);
  }
}
